/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Col, Container, Row, ButtonToolbar, UncontrolledTooltip } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { grey } from '@mui/material/colors';
import CardHistorico from './components/CardHistorico';

import BreadDetalhes from '../../../../App/Breadcrumbs/Obras/BreadDetalhes';
import FooterLinks from '../../../../Account/Footer';

import FuncionariosRecursos from '../../../../../redux/actions/RecursosActions/funcionariosAction';
import EncarregadosRecursos from '../../../../../redux/actions/RecursosActions/encarregadosAction';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },

  btnGuardar: {
    color: 'white',
    backgroundColor: '#E21450',
    width: '100px',
    height: '40px',
    fontWeight: 'bold',
  },
  btnGuardarLoading: {
    color: 'white',
    backgroundColor: grey[300],
    width: '120px',
    height: '40px',
  },
  btnMudarCor: {
    color: '#E21450',
    width: '100px',
    height: '40px',
    fontWeight: 'bold',
    // borderRadius: '15px',
    backgroundColor: 'white',
    border: `1px solid #707070`,
    display: 'flex',
    alignItems: 'center',
    transition: '0.2s',
    '&:hover': {
      backgroundColor: '#ECECEC',
      border: '1px solid #707070',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: '#F7F7F7 ',
      },
    },
  },
  btnMudarCorLoading: {
    color: 'white',
    backgroundColor: grey[300],
    width: '120px',
    height: '30px',
  },
  btnLightGreen: {
    color: '#FFFFFF',
    backgroundColor: '#E21450',
    '&:hover': {
      backgroundColor: '#44c9a3',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: '#44c9a3',
      },
    },
    width: '120px',
    height: '30px',
  },

  btnVoltar: {
    height: '30px',
    color: '#8f8f8f',
    '&:hover': {
      backgroundColor: '#e6e6e6',
    },
  },
}));

function Historico() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const fetchFuncionarios = () => {
    dispatch(FuncionariosRecursos());
  };

  const fetchEncarregados = () => {
    dispatch(EncarregadosRecursos());
  };

  useEffect(() => {
    fetchFuncionarios();
  }, []);
  useEffect(() => {
    fetchEncarregados();
  }, []);
  useEffect(() => {
    dispatch({ type: 'GET_HISTORICO_MENSAL', payload: [] });
  });
  useEffect(() => {
    dispatch({ type: 'GET_INFO_OBRAS', payload: {} });
  }, []);

  return (
    <>
      <Container>
        <Row>
          <Col md={12}>
            <BreadDetalhes />
            <h3 className="page-title" style={{ display: 'flex', flexDirection: 'row' }}>
              <Link to="/app/obras" style={{ textDecoration: 'none' }}>
                <ButtonToolbar
                  className="btn-toolbar--center"
                  style={{
                    marginRight: '10px',
                  }}
                >
                  <Button
                    id="TooltipBottom"
                    outline
                    className={classes.btnVoltar}
                    color="secondary"
                    size="sm"
                  >
                    <span
                      className="lnr lnr-chevron-left"
                      style={{ fontSize: 10, fontWeight: 900 }}
                    />
                  </Button>

                  <UncontrolledTooltip
                    // dir={dir}
                    placement="bottom"
                    target="TooltipBottom"
                  >
                    Voltar
                  </UncontrolledTooltip>
                </ButtonToolbar>
              </Link>
              <h4
                style={{
                  fontSize: '22px',
                  width: '100%',
                }}
                className="text-underline"
              >
                Detalhes da Obra
              </h4>
            </h3>
          </Col>
        </Row>
        <Row>
          <CardHistorico classes={classes} />
        </Row>
      </Container>
      <div className="bottom">
        <div style={{ padding: '20px 40px' }}>
          <FooterLinks />
        </div>
      </div>
    </>
  );
}

export default Historico;
